/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Specialists_AllInputs */

const en_portal_specialists_all = /** @type {(inputs: Portal_Specialists_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All specialists`)
};

const pl_portal_specialists_all = /** @type {(inputs: Portal_Specialists_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszyscy specjaliści`)
};

/**
* | output |
* | --- |
* | "All specialists" |
*
* @param {Portal_Specialists_AllInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_specialists_all = /** @type {((inputs?: Portal_Specialists_AllInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Specialists_AllInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_specialists_all(inputs)
	return en_portal_specialists_all(inputs)
});